"use client";

import { useEffect, useState } from "react";

export interface TocSection {
  id: string;
  label: string;
}

export function LegalToc({ sections }: { sections: TocSection[] }) {
  const [active, setActive] = useState(sections[0]?.id ?? "");

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (entry.isIntersecting) {
            setActive(entry.target.id);
          }
        }
      },
      { rootMargin: "-5% 0px -80% 0px" }
    );

    for (const { id } of sections) {
      const el = document.getElementById(id);
      if (el) {
        observer.observe(el);
      }
    }

    return () => observer.disconnect();
  }, [sections]);

  return (
    <nav aria-label="Page contents">
      <p className="mb-4 font-semibold text-[0.65rem] text-muted-foreground uppercase tracking-widest">
        Contents
      </p>
      <ul className="space-y-px">
        {sections.map(({ id, label }) => (
          <li key={id}>
            <a
              className={`block border-l-2 py-1.5 pl-3 text-sm leading-snug transition-all duration-150 ${
                active === id
                  ? "border-foreground font-medium text-foreground"
                  : "border-transparent text-muted-foreground hover:border-muted hover:text-foreground"
              }`}
              href={`#${id}`}
            >
              {label}
            </a>
          </li>
        ))}
      </ul>
    </nav>
  );
}
